var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import * as React from 'react';
import useRecorder from 'hooks/use-recorder';
import RecorderControls from './RecorderControls';
import presignedUrl from '../../services/api/presignedUrl';
import axios from 'axios';
import useAuthentication from 'hooks/use-authentication';
const AudioRecord = ({ durationTime, durationUnit, questionId, uploadRecording, getRawAnswer, question }) => {
    const _a = durationUnit === 'MINUTES' ?
        useRecorder(durationTime) :
        useRecorder(0, durationTime), { recorderState } = _a, handlers = __rest(_a, ["recorderState"]);
    const { getUserIdFromToken } = useAuthentication();
    const { oggFile } = recorderState;
    const bucketExamsAudioRecord = process.env.REACT_APP_SUMADI_BUCKET_EXAMS_AUDIO || 'sumadi-exams-audio-records-dev';
    const getPresignedUrl = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const userId = getUserIdFromToken();
        if (!userId) {
            throw Error('userId not found');
        }
        const mimetype = (_b = recorderState.oggFile) === null || _b === void 0 ? void 0 : _b.type;
        const extension = mimetype === null || mimetype === void 0 ? void 0 : mimetype.split('/')[1].split(';')[0];
        const path = `${userId}/${questionId}/record_exams.${extension}`;
        const urlValue = yield presignedUrl('putObject', bucketExamsAudioRecord, path);
        yield axios({
            headers: { 'Content-Type': 'multipart/form-data' },
            url: urlValue.presignedResponse,
            data: oggFile,
            method: 'PUT',
        });
        return path;
    });
    return (_jsx(React.Fragment, { children: _jsx("div", Object.assign({ className: "recorder-container" }, { children: _jsx(RecorderControls, { params: { durationTime, durationUnit, getRawAnswer, question, questionId }, recorderState: recorderState, handlers: handlers, uploadRecording: () => __awaiter(void 0, void 0, void 0, function* () {
                    const oggUrl = yield getPresignedUrl();
                    uploadRecording(oggUrl);
                    return oggUrl;
                }) }, void 0) }), void 0) }, void 0));
};
export default AudioRecord;
